import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPaddleIncompleteCheckoutPatch = {
    path: "/paddle/incomplete-checkout",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationPaddleIncompleteCheckoutPatch };
